import { appData } from '@/mocks/tanhua';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 max-w-4xl mx-auto">
          <div className="flex-1 w-full lg:w-auto text-center lg:text-left">
            <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-4">
              {appData.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
              {appData.desc}
            </p>

            <div className="grid grid-cols-2 gap-3 mb-6">
              {appData.features.map((feat, idx) => (
                <div key={idx} className="flex items-center gap-2 text-sm text-foreground-700">
                  <i className="ri-checkbox-circle-fill text-accent-500 flex-shrink-0"></i>
                  <span className="whitespace-nowrap">{feat}</span>
                </div>
              ))}
            </div>

            <a
              href="#hero"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap text-sm"
            >
              <i className="ri-smartphone-line"></i>
              <span>立即体验探花系列</span>
            </a>
          </div>

          <div className="flex-shrink-0">
            <div className="relative">
              <div className="absolute -inset-6 bg-accent-500/10 rounded-2xl blur-2xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20with%20warm%20dark%20screen%2C%20minimalist%20device%20on%20clean%20background%2C%20soft%20ambient%20lighting%2C%20elegant%20product%20photography%2C%20professional%20tech%20aesthetic&width=500&height=600&seq=tanhua-app-visual&orientation=portrait"
                alt="探花系列移动端体验入口"
                className="relative w-48 md:w-56 h-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}